<template>
    <div :class="[
        'cz2__panel',
        'cz2__panel--secondary',
        'cz2__design-side'
    ]">
        <focus-lock :disabled="focusLockDisabled">
            <div class="cz2__panel__header cz2__panel__header--with-back-button hide--below-sm">
                <div class="cz2__panel-header__back-button">
                    <button class="cz2__panel__back-button" :aria-label="$t('MENU_BACK')" @click.prevent="cancel"></button>
                </div>

                <details-header></details-header>
            </div>

            <div class="cz2__panel__body">
                <panel-header :title="`${$t('DESIGN_SIDE')} &mdash; ${selectedDesignSideDescription}`" />

                <!-- <div class="cz2__panel-body__back-button hide--below-sm">
                    <button class="cz2__panel__back-button" @click.prevent="cancel">
                        {{$t('DESIGN_SIDE')}} &mdash; {{selectedDesignSideDescription}}
                    </button>
                </div> -->

                <!-- <div class="cz2__mb-15 hide--above-sm">
                    <div class="cz2__type__small-header cz2__text--center">
                        {{$t('DESIGN_SIDE')}} &mdash; {{selectedDesignSideDescription}}
                    </div>
                </div> -->

                <div class="cz2__menu__items">
                    <menu-item
                        :title="$t('DESIGN_SIDE_FRONT')"
                        type="side-front"
                        :selected="selectedDesignSide === 'front'"
                        :hasIndicator="false"
                        @selected="selectSide('front')"
                    ></menu-item>

                    <menu-item
                        :title="$t('DESIGN_SIDE_BACK')"
                        type="side-back"
                        :selected="selectedDesignSide === 'back'"
                        :hasIndicator="false"
                        @selected="selectSide('back')"
                    ></menu-item>

                    <menu-item
                        :title="$t('DESIGN_SIDE_FRONTBACK')"
                        type="side-front-back"
                        :selected="selectedDesignSide === 'front-back'"
                        :hasIndicator="false"
                        @selected="selectSide('front-back')"
                    ></menu-item>

                    <menu-item
                        :title="$t('DESIGN_SIDE_BOTH')"
                        type="side-both"
                        :selected="selectedDesignSide === 'both'"
                        :hasIndicator="false"
                        @selected="selectSide('both')"
                    ></menu-item>
                </div>
            </div>

            <div class="cz2__panel__actions cz2__colors__actions--save-panel">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancel"><span>{{$t('ACTION_CANCEL')}}</span></button>
                <button class="cz2__panel-action cz2__panel-action--accept" @click.prevent="accept"><span>{{$t('ACTION_SAVE')}}</span></button>
            </div>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__design-side {
            .cz2__menu__items {
                @include respond-above(sm) {
                    margin-top: 25px;
                }
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    import DetailsHeader from './DetailsHeader.vue';
    import MenuItem from './MenuItem.vue';
    import PanelHeader from './PanelHeader.vue';

    export default {
        components: {
            FocusLock,
            DetailsHeader,
            MenuItem,
            PanelHeader,
        },
        data() {
            return {
                focusLockDisabled: true,
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Selected design side.
             */
            selectedDesignSide() {
                return this.$store.state.customizer.designSide;
            },
            /**
             * Selected design side description.
             */
            selectedDesignSideDescription() {
                const side = (this.selectedDesignSide || '').toUpperCase().replace('-', '');

                return this.$t(`DESIGN_SIDE_${side}_DESCRIPTION`);
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
            });

            // When the component is loaded, capture the current state of the view controller and save it in case
            // we need to revert to the previous state and toss away all customizations.
            //
            // At any given time there should be only one module that can do the revert.
            this.captureController();
        },
        methods: {
            /**
             * Captures the current state and active controller so we could cancel changes if necessary.
             */
            captureController() {
                if (this.viewController) {
                    this.revertDesignSide = this.selectedDesignSide;
                }
            },

            /**
             * Accept color choice.
             */
            accept() {
                // Keep the current configured view controller, and go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Reject color changes and restore the original selection.
             */
            cancel() {
                // Revert back to the state of the controller as was captured when the component was mounted.
                this.$store.dispatch('setDesignSide', this.revertDesignSide);

                // Go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Sets design side.
             */
            selectSide(side) {
                this.$store.dispatch('setDesignSide', side);
            },
        },
    };
</script>
